import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input } from 'antd';
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
import { funStrCheck } from 'rt-sd-common/sgiCommon/sgiCommon';
// import { addFormCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'


class SgiFormText extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        //初始化state属性
        this.initState();
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule 
     * @param {组件描述} moduleDesc 
     * @param {绑定实例ID} bdInst 
     * @param {对象工厂} objFct 
     * @param {make类型} type 
     */
    fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息       
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
        //添加拖拽布局信息 根据type类型
        // addFormCtlDndInfo(this, this.state.formItemProps, this.state.inputprops, type);
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc 
     * @param {属性} formItem 
     * @param {属性} inputprops 
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        //csstyle 样式文件?这个我还不知道怎么用
        var csstyle = moduleDesc.csstyle;

        //是否是密码控件
        var isPwd = moduleDesc.isPwd;
        if (isPwd) {
            inputprops.type = "password";
        }
    }

    /**
     * antd的Input组件bug，当存在后置文本时，组件会上偏1px，这里要进行偏移补偿
     */
    fixBdTextOnePxBug() {
        let inputprops = this.state.inputprops;
        let formItemProps = this.state.formItemProps;
        let addonAfter = inputprops.addonAfter;
        if (addonAfter) {
            let style = formItemProps.style;
            if (!style) {
                formItemProps.style = { marginTop: 4, marginBottom: -4 };
            } else if (style.marginTop) {
                style.marginTop += 4;
            } else if (style.marginBottom) {
                style.marginBottom -= 4;
            } else {
                style.marginTop += 4;
                style.marginBottom -= 4;
            }
        }
    }

    getShowCtl(_inputProps) {
        // 优先--用户自定义渲染组件
        let cstmRender = this.state.functions.cstmRender;
        if (cstmRender) {
            const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            return cstmRender(this, { ...this.state.inputprops, ..._inputProps }, this.state.inputprops.value, objFct);
        }

        if ((_inputProps.isLabel)) {
            return <span className="sgiFormItemSpan" {...this.state.inputprops} {..._inputProps}>{this.state.inputprops.value}<span style={{ marginLeft: "10px" }}>{this.state.inputprops.addonAfter}</span></span>
        } else {
            return <Input {...this.state.inputprops} {..._inputProps} />
        }
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        // this.fixBdTextOnePxBug();//修复antd后置文本导致偏移bug

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let ctl = this.getShowCtl(_inputProps);

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }
}

//给类添加公共方法
Object.assign(SgiFormText.prototype, sgiFormCtlBaseFun);

export { SgiFormText };
export default SgiFormText;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormText.js